import React from "react";
import {Select, Tooltip} from "antd";
import {useTranslation} from "react-i18next";

const PoolIntegrationTypeFilter = ({
    value,
    onChange,
    disabled = false,
    disabledTypes = [],
    disabledTypeReason = ""
}) => {
    const {t} = useTranslation(["common"]);

    const options = [
        {value: "", label: t("filters.integrationTypes.all", {ns: "common"})},
        {value: "dedicated", label: t("filters.integrationTypes.dedicated", {ns: "common"})},
        {value: "pool", label: t("filters.integrationTypes.pool", {ns: "common"})},
        {
            value: "dedicatedIntegration",
            label: t("filters.integrationTypes.dedicatedIntegration", {ns: "common"})
        }
    ];

    return (
        <Select
            value={value}
            onChange={onChange}
            disabled={disabled}
            style={{width: "100%"}}
            placeholder={t("filters.integrationType", {ns: "common"})}
        >
            {options.map(option => {
                const isOptionDisabled = disabledTypes.includes(option.value);
                return (
                    <Select.Option key={option.value} value={option.value} disabled={isOptionDisabled}>
                        {isOptionDisabled && disabledTypeReason ? (
                            <Tooltip
                                title={disabledTypeReason}
                                getPopupContainer={() => document.body}
                                overlayClassName="select-option-disabled-tooltip"
                            >
                                {/* Negatif margin + eşdeğer padding, hover alanını
                                    seçeneğin tüm satırına yayar. */}
                                <span
                                    style={{
                                        display: "block",
                                        margin: "-5px -12px",
                                        padding: "5px 12px"
                                    }}
                                >
                                    {option.label}
                                </span>
                            </Tooltip>
                        ) : (
                            option.label
                        )}
                    </Select.Option>
                );
            })}
        </Select>
    );
};

export default PoolIntegrationTypeFilter;
